<template>
  <div class="w-full max-w-[707px]">
    <div class="flex flex-col gap-4">
      <BettingShopBanner
        v-if="bettingShop"
        :betting-shop="bettingShop"
        @open-bar="isReviewBarOpen = true"
      />
    </div>
    <div class="h-[40px] hidden sm:flex items-center my-4">
      <p class="text-[12px] font-bold leading-[150%] tracking-[2.4px] uppercase text-base_white">
        {{ $t('commentsAndGradesOfUsers') }}
      </p>
    </div>
    <div class="flex flex-col mt-2 sm:mt-4">
      <BettingShopReviewComment
        v-for="(review, index) in bettingShopReviews"
        :key="index"
        :review="review"
      />
    </div>
    <div ref="observerPoint" />
  </div>
  <BettingShopReviewBar
    :betting-shop-id="parseInt(shopId as string)"
    :is-open="isReviewBarOpen"
    @close-bar="handleReviewBarClose"
    @review-created="handleReviewCreated"
  />
  <!-- <MobileBottomAppBar v-if="commonStore.isMobile">
    <ButtonComponent
      type="text"
      size="md"
      :text="`${$t('gradeAndCommentBettingShop')}`"
      @click="isReviewBarOpen = true"
    />
  </MobileBottomAppBar> -->
  <!-- nece nesto da radi sa ovim drugim uslovom na v-show, mislio sam to da stavim da se ne okida servis bzvz ponovo ali ne radi odjednom a radilo je?-->
  <BottomBettingShopsBar v-if="commonStore.isMobile && !isReviewBarOpen" />
</template>
<script lang="ts" setup>
import type { BettingShop } from '~/interfaces';
import { bettingShopRepository } from '~/repositories/bettingShopsRepository';
import { useCommonStore } from '~/store/commonStore';
const { $api } = useNuxtApp();
const { t } = useI18n();
const commonStore = useCommonStore();
const bettingShopRepo = bettingShopRepository($api);
const router = useRouter();
const route = useRoute();
const localePath = useLocalePath();
const shopId = route.params.id;
const bettingShopReviews: any = ref([]);
const isReviewBarOpen = ref(false);
const reviewsCursor = ref(null);
const observerPoint = ref(null);
let observer: IntersectionObserver | null = null;
const { $listen } = useNuxtApp();

const { data: bettingShop } = await useAsyncData<BettingShop>(
  'bettingShop',
  () => bettingShopRepo.getBettingShop(shopId as any),
  {
    server: true
  }
);
onMounted(async () => {
  await getBettingShopReview();
  if (route.query.review) {
    isReviewBarOpen.value = true;
  }
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMoreReviews();
        }
      });
    },
    {
      threshold: 0.5
    }
  );
  if (observerPoint.value) {
    observer.observe(observerPoint.value as any);
  }

  $listen('user:loginFromDialog', () => {
    isReviewBarOpen.value = true;
  });
});
onUnmounted(() => {
  if (observer && observerPoint.value) {
    observer.unobserve(observerPoint.value as Element);
    observer.disconnect();
  }
});
watch(
  () => route.query.review,
  (newValue) => {
    nextTick(() => {
      isReviewBarOpen.value = newValue === 'true';
    });
  }
);
const handleReviewBarClose = () => {
  isReviewBarOpen.value = false;
  const newQuery = { ...route.query };
  delete newQuery.review;
  router.replace({ path: localePath(route.path), query: newQuery });
};
const getBettingShopReview = async () => {
  const response = await bettingShopRepo.getBettingShopReviews(shopId as any);
  bettingShopReviews.value = response.reviews;
  reviewsCursor.value = response.nextCursor;
};
const handleReviewCreated = async (review: object) => {
  bettingShopReviews.value.unshift(review);
  bettingShop.value = await bettingShopRepo.getBettingShop(shopId as any);
};
const loadMoreReviews = async () => {
  if (reviewsCursor.value) {
    const reponse = await bettingShopRepo.getBettingShopReviews(shopId as any, reviewsCursor.value);
    const loadedReviews = reponse.reviews;
    bettingShopReviews.value.push(...loadedReviews);
    reviewsCursor.value = reponse.nextCursor;
  }
};

useHead({
  title: `${t('bettingShops')} - ${bettingShop.value?.name}`,
  meta: [
    {
      name: 'description',
      content: t('meta.bettingShopDynamic', [bettingShop.value?.name])
    },
    {
      name: 'keywords',
      content: t('meta.keywords')
    }
  ]
});
</script>
